import React, { Fragment, useRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Diagrams } from 'components/DataChartNew'
import DxDataTable from 'components/DxDataTable'
import { ContentBlock, ContentBlockLoading } from 'components/ContentBlock'
import useLocale from 'hooks/useLocale'
import getDxColumns from '../dxColumns'
import { StyledTableContainer } from './styled'

const AbcData = ({ loading, tableLoading, data = [], compareData = [], groupByColumns = [], filterColumns = [], visibleCompare, ...rest }) => {
	const [t] = useTranslation()
	const locales = useLocale()
	const tableRef = useRef({ groupBy: groupByColumns[0] })
	const dxColumns = useMemo(() => {
		const filteredColumns = getDxColumns({ t, locales })
		if(!visibleCompare) {
			return filteredColumns.filter(item => !item.compare)
		}
		return filteredColumns
	}, [locales, visibleCompare])
	const dataGridCols = dxColumns.filter(({ dataField }) => !filterColumns.includes(dataField))
	const setTableRef = ({ component }) => {
		const columns = component?.getVisibleColumns?.() || []
		tableRef.current.columns = columns
		tableRef.current.xCol = groupByColumns[0] || 'name'
	}
	return(
		<Fragment>
			<ContentBlockLoading blockId='1' isLoading={loading || tableLoading} alwaysExpanded topBorder showHeader={false}>
				<StyledTableContainer bgColor='#fffb0042' isBgColor={!!data.length}>
					<DxDataTable
						data={data}
						dataSource={{
							store: {
								type: 'array',
								data: data,
								onLoaded: arrData => {
									tableRef.current.rows = arrData
								}
							}
						}}
						columns={dataGridCols}
						groupBy={groupByColumns}
						height={508}
						label={t('statistic_section.sub_sections.abc_statistic')}
						manualGroup
						excelExport
						onInitialized={setTableRef}
						{...rest}
					/>
				</StyledTableContainer>
			</ContentBlockLoading>
			<ContentBlock blockId='2' label={t('statistic_section.strings.graphic')} unmountOnCollapse={true}>
				<Diagrams tableData={tableRef.current} />
			</ContentBlock>
		</Fragment>
	)
}

export default AbcData
